/**
 * Error Display Component - Shows error messages with retry option
 */

import { motion } from 'framer-motion';
import Button from './Button';
import { cn } from '@/utils/cn';
import { pageItem } from '@/utils/animations';

interface ErrorDisplayProps {
  message: string;
  onRetry?: () => void;
  className?: string;
}

const ErrorDisplay = ({ message, onRetry, className }: ErrorDisplayProps) => {
  console.log('❌ [ErrorDisplay] Error component rendered:', {
    message,
    hasRetry: !!onRetry,
    timestamp: new Date().toISOString()
  });

  const handleRetry = () => {
    console.log('🔄 [ErrorDisplay] Retry button clicked');
    onRetry?.();
  };

  return (
    <motion.div
      className={cn(
        'flex flex-col items-center justify-center',
        'p-6 rounded-card',
        'bg-soft-warning-50 border border-soft-warning-200',
        'text-center',
        className
      )}
      variants={pageItem}
      initial="hidden"
      animate="visible"
    >
      <motion.div
        className="text-4xl mb-4"
        animate={{ 
          rotate: [0, -10, 10, -10, 0],
          scale: [1, 1.1, 1]
        }}
        transition={{ 
          duration: 2,
          repeat: Infinity,
          repeatDelay: 3
        }}
      >
        😕
      </motion.div>
      
      <p className="text-soft-neutral-700 mb-4 text-sm leading-relaxed">
        {message}
      </p>
      
      {onRetry && (
        <Button
          onClick={handleRetry}
          variant="secondary"
          size="sm"
          className="text-xs"
        >
          تلاش مجدد
        </Button>
      )}
    </motion.div>
  );
};

export default ErrorDisplay;
